import React, { useState } from "react";

/**
 * Factura de ENTRADA (recepción) — versión limpia, ajustada para ticket.
 */

const SHOP_ADDRESS =
  " C. Eliseo Grullon 26, Santo Domingo 10131";
const SHOP_SITE = "PROOMTB.COM";
const LOGO_SRC = "https://i.ibb.co/ymqv0Bhw/PROOMTB-PNG.jpg";

// Pie de página
const Footer = ({ imageError, setImageError }) => (
  <div className="mt-4 text-xs" style={{ textAlign: "center" }}>
    {imageError ? (
      <p
        className="text-sm font-bold mb-3"
        style={{ height: 50, lineHeight: "50px" }}
      >
        [LOGO NO CARGADO]
      </p>
    ) : (
      <img
        src={LOGO_SRC}
        alt="PROOMTB Logo"
        onError={() => setImageError(true)}
        className="mx-auto"
        style={{ height: 50, width: "auto" }}
      />
    )}

    <div
      className="mt-2 text-xs leading-4"
      style={{ textAlign: "center" }}
    >
      <p>{SHOP_ADDRESS}</p>
      <p className="font-semibold">{SHOP_SITE}</p>
    </div>
  </div>
);

export function FacturaEntrada({ bike = {} }) {
  const [imageError, setImageError] = useState(false);

  const entryDate = bike?.entryDate ? new Date(bike.entryDate) : new Date();

  const formattedDate = entryDate.toLocaleDateString("es-DO", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const clientFullName = [bike.clientName, bike.clientLastName]
    .filter(Boolean)
    .join(" ");

  const renderRow = (label, value) =>
    value ? (
      <p className="text-sm leading-5">
        <span className="font-semibold">{label}: </span>
        <span>{value}</span>
      </p>
    ) : null;

  return (
    <div
      className="p-4 print-area ticket-print-format"
      style={{
        background: "#fff",
        color: "#000",
        textAlign: "left",
      }}
    >
      {/* Encabezado */}
      <h2
        className="text-lg font-bold mb-1"
        style={{ textAlign: "center" }}
      >
        Datos de Recepción
      </h2>

      <p
        className="text-xs mb-4"
        style={{ textAlign: "center" }}
      >
        {formattedDate}
      </p>

      {/* Datos */}
      <div className="space-y-1 mb-4">
        {renderRow("Cliente", clientFullName)}
        {renderRow("Teléfono", bike.phoneNumber)}
        {renderRow("Correo", bike.email)}

        {(bike.bikeBrand || bike.bikeModel || bike.serialNumber) && (
          <div
            style={{
              margin: "8px 0",
              borderTop: "1px dotted #ccc",
            }}
          />
        )}

        {renderRow("Marca", bike.bikeBrand)}
        {renderRow("Modelo", bike.bikeModel)}
        {renderRow("Serie", bike.serialNumber)}

        {bike.problem && (
          <div
            style={{
              margin: "8px 0",
              borderTop: "1px dotted #ccc",
            }}
          />
        )}

        {renderRow("Problema", bike.problem)}
      </div>

      {/* Separador */}
      <div
        className="my-4"
        style={{
          height: 1,
          width: "100%",
          background: "#000",
        }}
      />

      {/* Aviso Importante */}
      <div
        style={{
          border: "2px solid #d32f2f",
          borderRadius: "6px",
          padding: "10px",
          background: "#fff5f5",
          marginBottom: "16px",
        }}
      >
        <h3
          style={{
            margin: "0 0 8px",
            color: "#d32f2f",
            fontSize: "14px",
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          ⚠ AVISO IMPORTANTE
        </h3>

        <p
          style={{
            margin: 0,
            fontSize: "12px",
            lineHeight: "1.5",
            textAlign: "justify",
          }}
        >
          El cliente acepta que toda bicicleta que permanezca en nuestras
          instalaciones por más de <strong>20 días</strong> a partir de la fecha
          de ingreso o de la notificación de que el servicio ha sido finalizado,
          generará un cargo de <strong>RD$100.00 diarios</strong> por concepto
          de parqueo hasta el momento de su retiro.
        </p>
      </div>

      {/* Pie */}
      <Footer
        imageError={imageError}
        setImageError={setImageError}
      />
    </div>
  );
}

export default FacturaEntrada;
